import React, { useEffect, useState } from "react"
import { useHistory, useParams } from 'react-router-dom';
import { AdminIcon, AdminIcons } from "../Shared/AdminIcon";
import { CustomColumnContainer, ThreeColumnContainer, TwoColumnContainer } from "../Shared/Formelements";
import { ScreenHeader } from "../UI/Elements";
import { FetchHandler } from "../../Handlers/FetchHandler";
import { useUsers } from "../../hooks/useUsers";
import { Dialog } from "../Shared/Dialog";
import { useOrganizations } from "./useOrganizations";
import { StringHelper } from "../../Handlers/Helpers";
import { Routes } from "../../Handlers/ViewHandler";
import { OrganizationModelType, organizationReducer, OrganizationUsersModelType } from "../../rdx/organizationReducer";
import { AccountType } from "../../hooks/useAccountsAdmin";
import { ToolBar } from "../ToolBar/ToolBar";
import { MessageBoxes } from "../../Handlers/MessageBoxes";
import { EpochPicker } from "../AccountsAdmin";
type UpdatemodelType = {
    trialexpires?: number
    premiumexpires?: number
    istestorganization?: boolean,
    changed?: boolean
}
export const OrganizationsSettings = () => {


    const { id } = useParams();


    var nav = useHistory();
    const ui = useOrganizations();
    const org = ui.organizations?.[id];

    const [model, setModel] = useState<UpdatemodelType>({ istestorganization: !!(org?.istestorganization) });

    useEffect(() => {
        setModel({
            istestorganization: !!org?.istestorganization,
            premiumexpires: org?.premiumexpires,
            trialexpires: org?.trialexpires,
        });
    }, [org]);


    const [deleteOrgState, setDeleteOrgState] = useState<"none" | "sure">("none")


    return (

        <div className="screen-organizations">
            <ScreenHeader text={org?.name} icon={AdminIcons.house} />
            <div>
                <CustomColumnContainer gridTemplateColumns="250px auto 400px">
                    <div>
                        {/*
                        <div>
                            <EpochPicker
                                label={"Trial upphör"}
                                defaultValue={model?.trialexpires || org?.trialexpires}
                                onSave={epoch => setModel({ ...model, trialexpires: epoch, changed: true })}
                            />
                        </div>
                        <hr />
                     */}
                        <div>

                            <EpochPicker
                                label={"Premium upphör"}
                                defaultValue={model?.premiumexpires || org?.premiumexpires}
                                onSave={epoch => setModel({ ...model, premiumexpires: epoch, changed: true })}
                            />
                        </div>
                        <hr />
                        <div>
                            <label className="frm" htmlFor="istestorganiztion">Är testorganization</label>
                            <div>
                                <input id="istestorganiztion" style={{ width: "20px" }} type="checkbox" className="frm"
                                    checked={!!model?.istestorganization}
                                    onChange={e => setModel({ ...model, istestorganization: e.target.checked, changed: true })}
                                />
                            </div>
                        </div>
                        <hr />
                        {!!model.changed && (
                            <button onClick={async () => {
                                let p = { ...model };
                                if (p?.changed) { delete p.changed; }
                                await ui.onUpdateProps(id, p);
                            }} className="btn w100">Spara ändringar</button>

                        )}
                    </div>
                    <div></div>
                    <div>

                        <div>
                            {deleteOrgState === "none" && (
                                <button onClick={async () => setDeleteOrgState("sure")} className="btn">Radera organisation</button>
                            )}

                            {deleteOrgState === "sure" && (
                                <div>
                                    <button onClick={async () => setDeleteOrgState("none")} className="btn">Ångra</button>
                                    <button onClick={async () => {
                                        await ui.deleteOrganization(id);
                                        nav.go(-1);
                                    }}
                                        className="btn">Radera!</button>
                                </div>
                            )}
                        </div>

                        <table>
                            <thead>
                                <tr>
                                    <th></th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {Object.keys(org ?? {}).map(o => (
                                    <tr>
                                        <td>{o}</td>
                                        <td>{org?.[o]?.toString()}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>

                    </div>
                </CustomColumnContainer>
            </div>

        </div>
    )
}